document.addEventListener('DOMContentLoaded', function () {

    jQuery(document).on('click', '.navbar-toggler', function (e) {
        jQuery("nav.navbar").toggleClass('menu-opened');
    });

    jQuery(document).on('submit', 'form[data-form-type="contact"]', function (e) {
       e.preventDefault();
       if (grecaptcha.getResponse()) {
           let data = new FormData();
           let form_data = jQuery(this).serializeArray();

           form_data.push({"name": "action", "value": "piit_ajax_scripts"});
           form_data.push({"name": "form", "value": jQuery(this).attr('id')});
           form_data.push({"name": "piit_nnc", "value": piit_script_ajax_object.ajax_nonce});

           jQuery.each(form_data, function (key, input) {
               data.append(input.name, input.value);
           });

           if (document.getElementById('desc-pdf')) {
               let file_data = document.getElementById('desc-pdf').files;
               for (let i = 0; i < file_data.length; i++) {
                   data.append("desc-pdf[]", file_data[i]);
               }
           }

           if (document.getElementById('desc-img')) {
               let file_data = document.getElementById('desc-img').files;
               for (let i = 0; i < file_data.length; i++) {
                   data.append("desc-img[]", file_data[i]);
               }
           }

           jQuery('form button[type=submit]').addClass('btn-loader');

           jQuery.ajax({
               url: piit_script_ajax_object.ajax_url,
               method: 'post',
               dataType: 'json',
               data: data,
               processData: false,
               contentType: false,
               success: function (response) {
                   if (response.success === true) {
                       jQuery('form[data-form-type="contact"]').fadeOut(200);
                       jQuery('#success_message').text(response.data.msg).show();

                       jQuery([document.documentElement, document.body]).animate({
                           scrollTop: jQuery("#success_message").offset().top - 200
                       }, 500);
                       jQuery('form button[type=submit]').removeClass('btn-loader');
                   } else {
                       jQuery('form[data-form-type="contact"]').fadeOut(200);
                       jQuery('#success_message').addClass('alert-error').text(response.data.msg).show();
                       jQuery('form button[type=submit]').removeClass('btn-loader');
                       jQuery([document.documentElement, document.body]).animate({
                           scrollTop: jQuery("#success_message").offset().top - 200
                       }, 500);
                   }
               },
               error: function (e) {
                   jQuery('form[data-form-type="contact"]').fadeOut(200);
                   jQuery('#success_message').addClass('alert-error').text('Wystąpił błąd').show();
                   jQuery('form button[type=submit]').removeClass('btn-loader');
                   jQuery([document.documentElement, document.body]).animate({
                       scrollTop: jQuery("#success_message").offset().top - 200
                   }, 500);
               }
           });
       } else {
           grecaptcha.execute();
       }
    });

    function checkFlexGap() {
        // create flex container with row-gap set
        var flex = document.createElement("div");
        flex.style.display = "flex";
        flex.style.flexDirection = "column";
        flex.style.rowGap = "1px";

        // create two, elements inside it
        flex.appendChild(document.createElement("div"));
        flex.appendChild(document.createElement("div"));

        // append to the DOM (needed to obtain scrollHeight)
        document.body.appendChild(flex);
        var isSupported = flex.scrollHeight === 1; // flex container should be 1px high from the row-gap
        flex.parentNode.removeChild(flex);

        return isSupported;
    }

    if (!checkFlexGap()) {
        document.body.classList.add("flexbox-not-supported");
    }

    jQuery(document).on('click', '.calendar-icon', function (e) {
        jQuery('.calendar').removeClass('hidden');
        jQuery(".slick-lightbox").removeClass('hidden');
    });

    const date = new Date();

    const renderCalendar = () => {
        date.setDate(1);

        const monthDays = document.querySelector(".days");
        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();
        const prevLastDay = new Date(date.getFullYear(), date.getMonth(), 0).getDate();
        const firstDayIndex = date.getDay();
        const lastDayIndex = new Date(date.getFullYear(), date.getMonth() + 1, 0).getDay();

        let prevDays = firstDayIndex !== 0 ? firstDayIndex - 1 : 6;
        let nextDays = lastDayIndex > 0 ? 7 - lastDayIndex : 0;

        const months = [
            "styczeń",
            "luty",
            "marzec",
            "kwiecień",
            "maj",
            "czerwiec",
            "lipiec",
            "sierpień",
            "wrzesień",
            "październik",
            "listopad",
            "grudzień",
        ];

        document.querySelector(".date h3").innerHTML = "Wydarzenia " + months[date.getMonth()] + " " + date.getFullYear();

        let days = "";
        let prevDay = prevLastDay - prevDays + 1;

        let month = '-' + date.getMonth().toString().padStart(2,'0') + '-' + date.getFullYear();

        while (prevDay <= prevLastDay) {
            if (events[prevDay + month] || events["0" + prevDay + month]) {
                days += `<div class="prev-date event"><a href="/wydarzenia?d=${prevDay + month}" role="link">${prevDay++}</a></div>`;
            } else {
                days += `<div class="prev-date">${prevDay++}</div>`;
            }
        }

        let currentDate = new Date();
        month = '-' + (date.getMonth() + 1).toString().padStart(2,'0')  + '-' + date.getFullYear()

        for (let day = 1; day <= lastDay; day++) {
            if (events[day + month] || events["0" + day + month]) {
                days += `<div class="event` + (day === currentDate.getDate() && date.getMonth() === currentDate.getMonth() && date.getFullYear() === currentDate.getFullYear() ? ` today` : ``) + `"><a href="/wydarzenia?d=${day + month}" role="link">${day}</a></div>`;
            } else if (day === currentDate.getDate() && date.getMonth() === currentDate.getMonth() && date.getFullYear() === currentDate.getFullYear()) {
                days += `<div class="today">${day}</div>`;
            } else {
                days += `<div>${day}</div>`;
            }
        }

        month = '-' + (date.getMonth() + 2).toString().padStart(2,'0')  + '-' + date.getFullYear()

        for (let nextDay = 1; nextDay <= nextDays; nextDay++) {
            if (events[nextDay + month] || events["0" + nextDay + month]) {
                days += `<div class="prev-date event"><a href="/wydarzenia?d=${nextDay + month}" role="link">${nextDay}</a></div>`;
            } else {
                days += `<div class="next-date">${nextDay}</div>`;
            }
        }

        monthDays.innerHTML = days;

        jQuery(".slick-lightbox").show();
    };

    function monthDiff(d1, d2) {
        let months;
        months = (d2.getFullYear() - d1.getFullYear()) * 12;
        months -= d1.getMonth();
        months += d2.getMonth();
        return months;
    }

    if(document.querySelector("img.calendar-icon")) {
        renderCalendar();
        document.querySelector(".prev").addEventListener("click", () => {
            date.setMonth(date.getMonth() - 1);
            renderCalendar();
            if (monthDiff(new Date(), date) <= -1) {
                document.querySelector(".prev").classList.add("disabled");
            } else {
                document.querySelector(".prev").classList.remove("disabled");
                document.querySelector(".next").classList.remove("disabled");
            }
        });

        document.querySelector(".next").addEventListener("click", () => {
            date.setMonth(date.getMonth() + 1);
            renderCalendar();
             if (monthDiff(new Date(), date) >= 12) {
                 document.querySelector(".next").classList.add("disabled");
             } else {
                 document.querySelector(".prev").classList.remove("disabled");
                 document.querySelector(".next").classList.remove("disabled");
             }
        });

        document.querySelector("button.slick-lightbox-close, div.slick-lightbox-inner").addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            jQuery(".slick-lightbox").addClass('hidden');
            jQuery('.calendar').addClass('hidden');
        });
    }

    if(document.querySelector(".dropcontainer")) {
        const dropContainer = document.querySelector(".dropcontainer")
        const fileInput = dropContainer.querySelector('input[type=file]');

        dropContainer.addEventListener("dragover", (e) => {
            e.preventDefault()
        }, false)

        dropContainer.addEventListener("dragenter", () => {
            dropContainer.classList.add("drag-active")
        })

        dropContainer.addEventListener("dragleave", () => {
            dropContainer.classList.remove("drag-active")
        })

        dropContainer.addEventListener("drop", (e) => {
            e.preventDefault()
            dropContainer.classList.remove("drag-active")
            fileInput.files = e.dataTransfer.files
        })
    }

});

